import {
  addSavedItems,
  AddSavedItemsResponse,
} from "@repo/apis/customers-saveditems-v3";
import { SavedItemsSdkMethod } from "../utils/method-initializer";

type PublicAddSavedItemsMethod = (params: {
  items: [
    | {
        productId: number;
        variantId: number;
      }
    | {
        productId: number;
        colourWayId: number;
      },
  ];
}) => Promise<AddSavedItemsResponse>;
type AddSavedItemsMethod = SavedItemsSdkMethod<PublicAddSavedItemsMethod>;

export const addSavedItemsInitializer: AddSavedItemsMethod =
  ({ getAuthHeaderPredicate, ...context }) =>
  async ({ items }) => {
    try {
      const response = await addSavedItems({
        items,
        chameleonRequestInstance: context.chameleonRequestInstance,
        authHeader: await getAuthHeaderPredicate(),
        store: context.store,
        keyStoreDataversion: context.keyStoreDataversion,
        shop: context.shop,
        lang: context.lang,
        sizeSchema: context.sizeSchema,
        country: context.country,
        currency: context.currency,
      });

      return response;
    } catch (error) {
      console.error("Error adding saved items:", error);
      throw error;
    }
  };
